/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from './Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    pre: "pre",
    h3: "h3"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.BasicSize) _missingMdxReference("Examples.BasicSize", true);
  if (!Examples.ResponsiveSize) _missingMdxReference("Examples.ResponsiveSize", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "Flex.Item"
      }), " is a building block for ", _jsx(_components.a, {
        href: "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_flexible_box_layout",
        children: "CSS flexbox"
      }), " based layout of contents and components. Should be used in combination with ", _jsx(_components.a, {
        href: "/uilib/layout/flex/container/",
        children: "Flex.Container"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { Flex } from '@dnb/eufemia'\n\nrender(\n  <Flex.Container>\n    <Flex.Item>content</Flex.Item>\n  </Flex.Container>,\n)\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Size adjustment"
    }), "\n", _jsxs(_components.p, {
      children: ["You can provide a ", _jsx(_components.code, {
        children: "size"
      }), " prop with a number from 1 to 12 (can be changed in ", _jsx(_components.a, {
        href: "/uilib/layout/flex/container/",
        children: "Flex.Container"
      }), " with the ", _jsx(_components.code, {
        children: "sizeCount"
      }), " property)."]
    }), "\n", _jsx(_components.p, {
      children: "The number will be used to set the item size (a part of the container). It set a percentage unit and apply it on the item via CSS. When the container is tilled to 100%, the remaining items will wrap to a new row."
    }), "\n", _jsx(_components.p, {
      children: "The number 6 results in 50%, while 12 results in 100%."
    }), "\n", _jsx(Examples.BasicSize, {}), "\n", _jsx(_components.h3, {
      children: "Responsive size"
    }), "\n", _jsx(_components.p, {
      children: "You can also make sizes respond to media queries."
    }), "\n", _jsxs(_components.p, {
      children: ["For doing so, provide a ", _jsx(_components.code, {
        children: "size"
      }), " prop with an object containing ", _jsx(_components.a, {
        href: "/uilib/usage/layout/media-queries/",
        children: "Media Query"
      }), " types. Each media size should contain number, like mentioned above."]
    }), "\n", _jsx(Examples.ResponsiveSize, {}), "\n", _jsxs(_components.p, {
      children: ["You need to ensure that ", _jsx(_components.code, {
        children: "flex-wrap: wrap"
      }), " is set, so the remaining items wrap to a new row when needed. This is enabled by default in the ", _jsx(_components.a, {
        href: "/uilib/layout/flex/container/",
        children: "Flex.Container"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
